export default "__VITE_ASSET__8uDGJzlW__ 400w, __VITE_ASSET__B_INHf8N__ 800w, __VITE_ASSET__YV2QbV1B__ 1024w";